export default __webpack_public_path__ + "static/media/safetyvr.b9f68cdf.png";